__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "otms-odyssey-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/animations/browser", "17.2.0", () => (__webpack_require__.e(3036).then(() => (() => (__webpack_require__(655))))));
			register("@angular/animations", "17.2.0", () => (__webpack_require__.e(7172).then(() => (() => (__webpack_require__(7172))))));
			register("@angular/cdk/a11y", "17.2.0", () => (__webpack_require__.e(2102).then(() => (() => (__webpack_require__(2102))))));
			register("@angular/cdk/bidi", "17.2.0", () => (__webpack_require__.e(1299).then(() => (() => (__webpack_require__(3680))))));
			register("@angular/cdk/coercion", "17.2.0", () => (__webpack_require__.e(433).then(() => (() => (__webpack_require__(2814))))));
			register("@angular/cdk/collections", "17.2.0", () => (__webpack_require__.e(7989).then(() => (() => (__webpack_require__(7989))))));
			register("@angular/cdk/drag-drop", "17.2.0", () => (__webpack_require__.e(8473).then(() => (() => (__webpack_require__(854))))));
			register("@angular/cdk/keycodes", "17.2.0", () => (__webpack_require__.e(4879).then(() => (() => (__webpack_require__(4879))))));
			register("@angular/cdk/layout", "17.2.0", () => (__webpack_require__.e(7912).then(() => (() => (__webpack_require__(7912))))));
			register("@angular/cdk/observers", "17.2.0", () => (__webpack_require__.e(9539).then(() => (() => (__webpack_require__(9539))))));
			register("@angular/cdk/platform", "17.2.0", () => (__webpack_require__.e(7699).then(() => (() => (__webpack_require__(7699))))));
			register("@angular/cdk/scrolling", "17.2.0", () => (__webpack_require__.e(9975).then(() => (() => (__webpack_require__(9975))))));
			register("@angular/common/http", "17.3.12", () => (__webpack_require__.e(6443).then(() => (() => (__webpack_require__(6443))))));
			register("@angular/common", "17.2.0", () => (__webpack_require__.e(7935).then(() => (() => (__webpack_require__(316))))));
			register("@angular/core/primitives/signals", "17.2.0", () => (__webpack_require__.e(5689).then(() => (() => (__webpack_require__(5689))))));
			register("@angular/core", "17.2.0", () => (__webpack_require__.e(7580).then(() => (() => (__webpack_require__(7580))))));
			register("@angular/forms", "17.2.0", () => (__webpack_require__.e(2075).then(() => (() => (__webpack_require__(4456))))));
			register("@angular/platform-browser/animations", "17.2.0", () => (__webpack_require__.e(6216).then(() => (() => (__webpack_require__(3835))))));
			register("@angular/platform-browser", "17.2.0", () => (__webpack_require__.e(436).then(() => (() => (__webpack_require__(436))))));
			register("@angular/router", "17.2.0", () => (__webpack_require__.e(2691).then(() => (() => (__webpack_require__(5072))))));
			register("@oneodyssey/ui", "2.0.0", () => (__webpack_require__.e(8263).then(() => (() => (__webpack_require__(644))))));
			register("aws-amplify", "6.0.0", () => (__webpack_require__.e(2214).then(() => (() => (__webpack_require__(9833))))));
			register("lucide-angular", "1.0.0", () => (__webpack_require__.e(4284).then(() => (() => (__webpack_require__(1903))))));
			register("rxjs/operators", "7.8.0", () => (__webpack_require__.e(3620).then(() => (() => (__webpack_require__(3620))))));
			register("rxjs", "7.8.0", () => (__webpack_require__.e(1340).then(() => (() => (__webpack_require__(1340))))));
			initExternal(5962);
			initExternal(3062);
			initExternal(9502);
			initExternal(4103);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};